import Medusa from '@medusajs/medusa-js'
import creds from '../../creds'

let MEDUSA_BACKEND_URL = creds?.medusa_backend_url 

export const createClient = () => new Medusa({ baseUrl: MEDUSA_BACKEND_URL, maxRetries: 3 })
